// Base CSS commune A4. singlePage=true force height:297mm + overflow:hidden
// (empêche le débordement qui causait les bugs récurrents sur les fiches
// imprimées en une page). singlePage=false laisse le contenu couler sur
// plusieurs pages via page-break-before (ex: emploi du temps semaine A/B).
export function printBaseCss(singlePage = true, pageMargin = '0', orientation = 'portrait') {
  const width = orientation === 'landscape' ? '297mm' : '210mm';
  const height = orientation === 'landscape' ? '210mm' : '297mm';
  return `
  @page {
    size: A4 ${orientation};
    margin: ${pageMargin};
  }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body {
    width: ${width};
    ${singlePage ? `height: ${height}; overflow: hidden;` : ''}
  }
  .print-page {
    width: ${width};
    ${singlePage ? `height: ${height}; overflow: hidden;` : `min-height: ${height};`}
    padding: ${pageMargin === '0' ? '12mm 14mm 10mm 14mm' : '0'};
    font-family: Arial, Helvetica, sans-serif;
    color: #1a2332;
    display: flex;
    flex-direction: column;
  }
`;
}

export const PRINT_BASE_CSS = printBaseCss(true);

/**
 * Ouvre une fenêtre d'impression, écrit le HTML, déclenche print() puis close().
 * bodyHtml doit être enveloppé dans une div class="print-page" par l'appelant.
 * options.singlePage = false pour les documents multi-page (page-break-before).
 */
export function openPrintWindow(title, bodyHtml, extraCss = '', windowFeatures = 'height=900,width=1000', options = {}) {
  const { singlePage = true, pageMargin = '0', orientation = 'portrait' } = options;

  const html = `
    <!DOCTYPE html>
    <html lang="fr">
      <head>
        <meta charset="utf-8"/>
        <title>${title}</title>
        <style>${printBaseCss(singlePage, pageMargin, orientation)}${extraCss}</style>
      </head>
      <body>${bodyHtml}</body>
    </html>`;

  const printWindow = window.open('', '_blank', windowFeatures);
  if (printWindow) {
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.onload = function () {
      printWindow.print();
      printWindow.close();
    };
    return printWindow;
  }

  // Fallback si la popup est bloquée : impression via iframe caché
  const printFrame = document.createElement('iframe');
  printFrame.style.position = 'absolute';
  printFrame.style.top = '-10000px';
  printFrame.style.left = '-10000px';
  document.body.appendChild(printFrame);

  const frameDoc = printFrame.contentDocument || printFrame.contentWindow.document;
  frameDoc.write(html);
  frameDoc.close();

  setTimeout(() => {
    printFrame.contentWindow.focus();
    printFrame.contentWindow.print();
    setTimeout(() => {
      document.body.removeChild(printFrame);
    }, 1000);
  }, 500);
  return null;
}
